module.exports = __webpack_public_path__ + "img/1024.bec072ef.svg";